import { useEffect } from 'react';

import { REACT_APP_API_URL } from '@/helpers/conf';
import { CLIENT_ENVS } from '@/helpers/constants';
import { useCommonStore } from '@/store';

export const usePaymentsConfig = () => {
  const isAuthenticated = useCommonStore.use.isAuthenticated();
  const user = useCommonStore.use.user();

  useEffect(() => {
    window.PaymentsAPI?.config({
      ...(CLIENT_ENVS.APP_ENV !== 'development' && {
        serverUrl: REACT_APP_API_URL,
      }),
      language: 'en',
      cdnList: ['https://cdn.softswiss.net', 'https://cdn2.softswiss.net'],
    });
  }, []);

  useEffect(() => {
    if (!isAuthenticated) return;
    window.PaymentsAPI?.resetCache().then(() => {
      console.log('resetCache');
    });
  }, [isAuthenticated, user]);
};
